export default __webpack_public_path__ + "static/luke-gamble-logo-bottom-c2eb99649cc10dc4d20e874d1eade678.png";